var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTool3DRotate = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m10 24.996 2.5-1.998-2.5-2.002"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 22.998c-3.462.654-7.5-1.5-8.5-5M18 3l-2.5 1.998L18 7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 4.998c3.462-.654 7.5 1.5 8.5 5M14 8.75l-5 2.188 5 2.187 5-2.187z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 10.938v5.937l5 2.188 5-2.188v-5.937M14 13.125v5.938"
})))));
export { SvgTool3DRotate as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-3d-rotate.svg";